module.exports = __webpack_public_path__ + "static/media/b-sci-major-41_LR.77dee097.jpg";